import _copyObject_default from "./_copyObject.js";
import _getSymbolsIn_default from "./_getSymbolsIn.js";

//#region ../../node_modules/lodash-es/_copySymbolsIn.js
/**
* Copies own and inherited symbols of `source` to `object`.
*
* @private
* @param {Object} source The object to copy symbols from.
* @param {Object} [object={}] The object to copy symbols to.
* @returns {Object} Returns `object`.
*/
function copySymbolsIn(source, object) {
	return _copyObject_default(source, _getSymbolsIn_default(source), object);
}
var _copySymbolsIn_default = copySymbolsIn;

//#endregion
export { _copySymbolsIn_default as default };
//# sourceMappingURL=_copySymbolsIn.js.map